import { UserBasic } from 'types/user';
import { ReferenceTemplate } from 'types/application';

export const getCandidateStatusName = (
  statusId: string,
  applicationStatuses?: Array<{ id?: number; label?: string }>
): string | undefined => {
  const status = applicationStatuses?.find((status) => status.id === Number(statusId));
  return status?.label;
};

export const getEmailTemplateName = (
  templateId: string,
  emailTemplates?: Array<{ id: number; title: string }>
): string | undefined => {
  const template = emailTemplates?.find((template) => template.id === Number(templateId));
  return template?.title;
};

export const getReferenceTemplateName = (
  templateId: string,
  referenceTemplatesData?: ReferenceTemplate[]
): string | undefined => {
  const template = referenceTemplatesData?.find((template) => template.id === Number(templateId));
  return template?.title;
};

export const getSenderName = (
  userId: string,
  superAndDistrictAdmins?: UserBasic[]
): string | undefined => {
  const sender = superAndDistrictAdmins?.find((admin) => admin.id === Number(userId));
  return sender?.name;
};
